import i18n from '@/localisation/i18n';

export const EditField = ({
  isEditing,
  name,
  updatedName,
  setUpdatedName,
}: {
  isEditing: boolean;
  name: string | undefined;
  updatedName: string | undefined;
  setUpdatedName: (name: string) => void;
}) => {
  if (!isEditing && !name) return null;

  if (isEditing) {
    return (
      <input
        value={updatedName}
        type="text"
        className="input input-bordered mt-3 w-full gap-2 bg-[#42404D]"
        placeholder={i18n.t('full.name')}
        onChange={e => {
          setUpdatedName(e.target.value);
        }}
      />
    );
  }

  return <div className="mt-3 text-lg">{name}</div>;
};
